// src/components/layout/Head.tsx
import React from 'react';
import { Helmet } from 'react-helmet-async';

interface HeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  ogImage?: string;
  ogUrl?: string;
}

const Head: React.FC<HeadProps> = ({
  title = "Lux Decor by Kamen | Luksuzna kopalniška oprema",
  description = "Odkrijte brezčasno eleganco in vrhunsko kakovost naših luksuznih kopalniških izdelkov, ki bodo vašo kopalnico spremenili v oazo miru in razkošja.",
  keywords = "luksuzna kopalnica, kopalniški dodatki, umivalniki, pohištvo, svetila, ogledala",
  ogImage = "/luxdecor-og.jpg",
  ogUrl = "https://luxdecor.si"
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={ogUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={ogUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />
      
      {/* Google Analytics */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-XXXXXXXXXX"></script>
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-XXXXXXXXXX');
        `}
      </script>
    </Helmet>
  );
};

export default Head;